// extracted by mini-css-extract-plugin
export default {"resultsContainer":"SearchOptions_resultsContainer__CAoEt"};